<!-- @format -->

<div class="cdialog" style="min-height: 300px; max-height: 80vh;">
  <div class="dialogHeader">
    <div mat-dialog-title>{{_common.poster_display}}</div>

    <div class="spacer"></div>
    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content class="max-height">
    <div class="max-height">
      <app-agent-content-list [agent]="object"> </app-agent-content-list>
    </div>
  </mat-dialog-content>
</div>
